import { requestBuilder } from '../../../http/RequestBuilder';

export interface TransactionSimulationData {
    amount: number;
    card_acceptor: {
        partial_approval_capable: boolean;
        mcc: string;
        name: string;
        address: string;
        city: string;
        state: string;
        zip: string;
        country: string;
    };
    card_options: {
        card_present: boolean;
    };
    is_pre_auth: boolean;
    transaction_options: {
        is_async: boolean;
        send_expiration_date: boolean;
        send_track_data: boolean;
    };
    mid: string;
    network_fees?: {
        amount: number;
        credit_debit?: string;
        type: string;
    };
    original_transaction_id?: string;
}

export interface CreateTransactionSimulationRequest {
    path: string;
    cardId: string;
    data: Partial<TransactionSimulationData>;
}

// Typed as object in simulation API response - below generated based on observing auth responses. Only rendered fields currently included
export interface CreateTransactionSimulationResponse {
    transaction: {
        token: string;
        state: string;
        response: {
            code: string;
            memo: string;
        };
        type: string;
    };
}

const useCreateTransactionSimulation = requestBuilder.mutation<
    CreateTransactionSimulationResponse,
    CreateTransactionSimulationRequest
>({
    endpoint: '/api/transaction-simulations/simulate',
    method: 'POST',
});

export default useCreateTransactionSimulation;
